
import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'

/* Layout */
import Layout from '@/layout/index.vue'

Vue.use(Router)


export const constantRoutes: RouteConfig[] = [
  {
    path: '/redirect',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path*',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '/auth-redirect',
    component: () => import(/* webpackChunkName: "auth-redirect" */ '@/views/login/auth-redirect.vue'),
    meta: { hidden: true }
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '/',
    redirect: '/home/index',
    component: Layout,
    name: 'homeMan',
    meta: { title: '首页', icon: 'home' },
    children: [
      {
        path: '/home/index',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', icon: 'home' },
      }
    ],
  }
]

export const asyncRoutes: RouteConfig[] = [
  {
    path: '/organization',
    component: Layout,
    redirect: '/organization/index',
    name: 'organizationMana',
    meta: { title: '组织管理', icon: 'bug', roles: ['admin']},
    children: [
      {
        path: 'index',
        name: 'organization',
        component: () => import('@/views/organization/index.vue'),
        meta: { title: '组织', icon: 'bug' },
      },
      {
        path: '/organization/accountInformation',
        name: 'accountInformation',
        component: () => import('@/views/organization/organizationUser.vue'),
        meta: { title: '组织 / 账号', hidden: true }
      }
    ],
  },
  {
    path: '/maintenceInfo',
    component: Layout,
    name: 'MaintenceInfo',
    meta: { title: '维保信息', icon: 'nested', roles: ['admin', 'maintenence'] },
    children: [
      {
        path: '/person',
        name: 'person',
        component: () => import('@/views/person/index.vue'),
        meta: { title: '人员', icon: 'user' },
      },
      {
        path: '/department',
        name: 'department',
        meta: { title: '部门', icon: 'table'},
        component: () => import('@/views/department/index.vue'),
      },
      {
        path: '/project',
        name: 'project',
        meta: { title: '项目', icon: 'fullscreen'},
        component: () => import('@/views/project/index.vue'),
      },
      {
        path: '/elevator',
        name: 'elevator',
        meta: { title: '电梯', icon: 'example' },
        component: () => import('@/views/elevator/elevator.vue'),
      }
    ]
  },
  {
    path: '/propertyInfo',
    component: Layout,
    name: 'propertyInfo',
    meta: { title: '物业信息', icon: 'nested', roles: ['admin', 'property', 'special'] },
    children: [
      {
        path: '/propertyInfo/person',
        name: 'propertyPerson',
        component: () => import('@/views/property/propertyPerson.vue'),
        meta: { title: '人员', icon: 'user' },
      },
      {
        path: '/propertyInfo/group',
        name: 'propertyGroup',
        component: () => import('@/views/property/propertyGroup.vue'),
        meta: { title: '部门', icon: 'table' }
      },
      {
        path: '/propertyInfo/group/groupDetail',
        name: 'groupDetail',
        component: () => import('@/views/property/groupDetail.vue'),
        meta: { title: '保洁组 / 人员信息', hidden: true }
      },
      {
        path: '/propertyInfo/area',
        name: 'propertyArea',
        component: () => import('@/views/property/propertyArea.vue'),
        meta: { title: '区域', icon: 'area' }
      },
      {
        path: '/propertyInfo/equipment',
        name: 'propertyEquipment',
        component: () => import('@/views/property/equipment.vue'),
        meta: { title: '设备', icon: 'equipment' }
      }
    ]
  },
  {
    path: '/Task',
    component: Layout,
    name: 'TaskManage',
    meta: { title: '电梯任务', icon: 'tree', roles: ['admin']},
    children: [
      {
        path: '/task',
        name: 'task',
        component: () => import('@/views/task/task.vue'),
        meta: { title: '维保任务', icon: 'link'},
      },
      // {
      //   path: '/manualTask',
      //   name: 'manualTask',
      //   component: () => import('@/views/task/manualTask.vue'),
      //   meta: { title: '手动任务', icon: 'link'},
      // },
      // {
      //   path: '/autoTask',
      //   name: 'autoTask',
      //   component: () => import('@/views/task/autoTask.vue'),
      //   meta: { title: '自动任务', icon: 'link'},
      // },
      {
        path: '/rescueTask',
        name: 'rescueTask',
        component: () => import('@/views/task/rescueTask.vue'),
        meta: { title: '救援任务', icon: 'link'},
      },
      {
        path: 'troubleshootngTask',
        name: 'defaultShootngTask',
        component: () => import('@/views/task/troubleshootingTask.vue'),
        meta: { title: '维修任务', icon: 'link' },
      }
    ]
  },
  {
    path: '/report',
    component: Layout,
    redirect: '/report/index',
    name: 'reportManage',
    meta: { title: '电梯报表', icon: 'form', roles: ['admin', 'maintenence'] },
    children: [
      {
        path: 'todayTask',
        name: 'todayTask',
        component: () => import('@/views/report/todayTask.vue'),
        meta: { title: '今日任务', icon: 'form' },
      },
      {
        path: 'maintenanceTask',
        name: 'maintenanceTask',
        component: () => import('@/views/report/maintenanceTask.vue'),
        meta: { title: '维保记录', icon: 'form' },
      },
      {
        path: 'helpTask',
        name: 'helpTask',
        component: () => import('@/views/report/helpTask.vue'),
        meta: { title: '救援记录', icon: 'form' },
      },
      {
        path: 'troubleshootngTask',
        name: 'troubleshootngTask',
        component: () => import('@/views/report/troubleShootingTask.vue'),
        meta: { title: '维修记录', icon: 'form' },
      },
      {
        path: '/yearlyInspection',
        name: 'yearlyInspection',
        component: () => import('@/views/report/yearlyInspection.vue'),
        meta: { title: '年检记录', icon: 'form'}
      },
      {
        path: 'elevatorStatus',
        name: 'elevatorStatus',
        component: () => import('@/views/report/elevatorStatus.vue'),
        meta: { title: '电梯状态', icon: 'form' },
      }
    ]
  },
  {
    path: '/propertyReport',
    component: Layout,
    name: 'propertyReportMana',
    meta: { title: '物业报表', icon: 'form', roles: ['admin', 'property'] },
    children: [
      {
        path: 'cleanSummary',
        name: 'cleanSummary',
        component: () => import('@/views/propertyReport/cleanSummary.vue'),
        meta: { title: '保洁汇总', icon: 'form' },
      },
      {
        path: 'cleanDetails',
        name: 'cleanDetails',
        component: () => import('@/views/propertyReport/cleanDetails.vue'),
        meta: { title: '保洁明细', icon: 'form' },
      },
      {
        path: 'cleanDormitorySummary',
        name: 'cleanDormitorySummary',
        component: () => import('@/views/propertyReport/cleanDormitorySummary.vue'),
        meta: { title: '查寝汇总', icon: 'form' },
      },
      {
        path: 'cleanDormitoryDetails',
        name: 'cleanDormitoryDetails',
        component: () => import('@/views/propertyReport/cleanDormitoryDetails.vue'),
        meta: { title: '查寝明细', icon: 'form' },
      },
      {
        path: 'equipmentSummary',
        name: 'equipmentSummary',
        component: () => import('@/views/propertyReport/equipmentSummary.vue'),
        meta: { title: '设备巡检汇总', icon: 'form' },
      },
      {
        path: 'equipmentDetail',
        name: 'equipmentDetail',
        component: () => import('@/views/propertyReport/equipmentDetail.vue'),
        meta: { title: '设备巡检明细', icon: 'form' },
      }
    ]
  },
  {
    path: '/machineRoomReport',
    component: Layout,
    redirect: '/machineRoomReport/index',
    name: 'machineRoomReportManage',
    meta: { title: '机房报表', icon: 'form', roles: ['special'] },
    children: [
      {
        path: 'todayTask',
        name: 'todayTask',
        component: () => import('@/views/propertyReport/machineRoomTask.vue'),
        meta: { title: '今日任务', icon: 'form' },
      },
      {
        path: 'maintenanceTask',
        name: 'maintenanceTask',
        component: () => import('@/views/propertyReport/machineRoomDetails.vue'),
        meta: { title: '机房巡检记录', icon: 'form' },
      },
      {
        path: 'registration',
        name: 'registration',
        component: () => import('@/views/propertyReport/registrationsDetails.vue'),
        meta: { title: '机房登记记录', icon: 'form' },
      }
    ]
  },
  {
    path: '/propertyReportBySK',
    component: Layout,
    name: 'propertyReportBySKMana',
    meta: { title: '报表统计', icon: 'form', roles: ['special'] },
    children: [
      {
        path: 'cleanSummary',
        name: 'cleanSummary',
        component: () => import('@/views/propertyReport/cleanSummary.vue'),
        meta: { title: '保洁汇总', icon: 'form' },
      },
      {
        path: 'cleanDetails',
        name: 'cleanDetails',
        component: () => import('@/views/propertyReport/cleanDetails.vue'),
        meta: { title: '保洁明细', icon: 'form' },
      },
      {
        path: 'equipmentSummary',
        name: 'equipmentSummary',
        component: () => import('@/views/propertyReport/equipmentSummary.vue'),
        meta: { title: '设备巡检汇总', icon: 'form' },
      },
      {
        path: 'equipmentDetail',
        name: 'equipmentDetail',
        component: () => import('@/views/propertyReport/equipmentDetail.vue'),
        meta: { title: '设备巡检明细', icon: 'form' },
      }
    ]
  },
  {
    path: '/messasge',
    component: Layout,
    name: 'message',
    meta: { title: '消息', icon: 'link', roles: ['admin']},
    children: [
      {
        path: '/allMessage',
        name: 'allMessage',
        component: () => import('@/views/message/message.vue'),
        meta: { title: '消息', icon: 'form'},
      }
    ]
  },
  {
    path: '/subTaskDetail',
    component: () => import('@/views/report/subTaskDetail.vue')
  },
  {
    path: '/cleanPreview',
    component: () => import('@/views/propertyReport/cleanPreview.vue')
  },
  {
    path: '/equipmentPreview',
    component: () => import('@/views/propertyReport/equipmentPreview.vue')
  },
  {
    path: '/template',
    component: Layout,
    name: 'templateManage',
    meta: { title: '模版管理', icon: 'example', roles: ['admin']},
    children: [
      {
        path: '/template',
        name: 'template',
        component: () => import('@/views/template/index.vue'),
        meta: { title: '模版', icon: 'example'},
      }
    ]
  },
  {
    path: '/updatePassword',
    component: Layout,
    name: 'updatePassword',
    meta: { title: '修改密码', hidden: true },
    children: [
      {
        path: 'index',
        component: () => import('@/views/system/updatePassword.vue'),
        meta: { title: '修改密码', hidden: true }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
]

const createRouter = () => new Router({
  // mode: 'history',  // Disabled due to Github Pages doesn't support this, enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router

